import React, { useContext } from 'react';
import { CustomersContext, ICustomersContext } from '../../customersState/customersContext';
import { EntityStatus, UserRoles } from 'types';
import { customersSortOptions } from 'appConstants';
import { ListingControlPanel } from 'components/Listing/ListingControlPanel';
import { ListingControlPanelRow } from 'components/Listing/ListingControlPanelRow';
import { SearchFieldNew } from 'components/SearchField/SearchFieldNew';
import { CreateButton } from 'components/Listing/CreateButton';
import { ResetButton } from 'components/Listing/ResetButton';
import { SortAndCountDropdown } from 'components/SortAndCountDropdown/SortAndCountDropdown';
import { ClientTypeSelect } from './ClientTypeSelect';
import { StatusSelect } from './StatusSelect';
import { WithURLFilters } from './WithURLFilters';

export const CustomersControlPanel: React.FC = () => {
	const {
		changeSearchString,
		searchString,
		customers,
		resetSelectedControls,
		status,
		selectedClientType,
		sortBy,
		countOfItems,
		setSortBy,
		setCountOfItems,
	} = useContext<ICustomersContext>(CustomersContext);

	const hasActiveFilters = !!searchString || !!selectedClientType || status !== EntityStatus.Active;

	return (
		<WithURLFilters>
			<ListingControlPanel testId="CustomersControlPanel">
				<ListingControlPanelRow>
					<SearchFieldNew
						onChangeSelectSearchString={changeSearchString}
						searchString={searchString}
						delay={customers.customerCount ? 800 : undefined}
						size="large"
					/>
					<CreateButton
						to="/clients/customers-new-ui/create"
						translationKey="createClientButton"
						roles={[UserRoles.SUPER_USER]}
					/>
				</ListingControlPanelRow>
				<ListingControlPanelRow>
					<ClientTypeSelect />
					<StatusSelect />
					<ResetButton disabled={!hasActiveFilters} onClick={resetSelectedControls} />
					<SortAndCountDropdown
						sortBy={sortBy}
						sortOptions={customersSortOptions}
						countOfItems={countOfItems}
						testId="SortAndCountDropdown"
						onSortByChange={setSortBy}
						onCountOfItemsChange={setCountOfItems}
					/>
				</ListingControlPanelRow>
			</ListingControlPanel>
		</WithURLFilters>
	);
};
